<!-- eslint-disable -->
<template>
  <CommonPages id="names" :class="['names']" titlePrefix="All">
    <!-- 搜索过滤区域 -->
    <div class="names-filter" :class="[deviceType]">
      <SearchFilter class="search-filter-style" :initial-filters="filters"
        :is-collapsible="deviceType == 'mobile'" :key="JSON.stringify(filters)" />
    </div>
   
    <!-- 结果标题区域 -->
    <div class="results-header" :class="[deviceType]">
      <!-- PC版布局 -->
      <template v-if="deviceType !== 'mobile'">
        <div class="results-title">Combinations</div>
        <div class="sort-container">
          <span class="sort-label">Sort By:</span>
          <el-select v-model="sortBy" class="sort-select" popper-class="sort-dropdown">
            <el-option v-for="item in sortOptions" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </div>
      </template>
      <!-- 移动端布局 -->
      <template v-else>
        <div class="results-header-top">
          <div class="results-title">Combinations</div>
        </div>
        <div class="sort-container">
          <span class="sort-label">Sort By:</span>
          <el-select v-model="sortBy" class="sort-select" popper-class="sort-dropdown">
            <el-option v-for="item in sortOptions" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </div>
      </template>
    </div>

    <!-- 名字列表区域 -->
    <div class="names-list" :class="[deviceType]">
      <template v-for="(card, index) in nameCards">
        <router-link :key="index" :to="`/names/${card.name.toLowerCase()}/${card.id}`" tag="div"
          class="name-card-link">
          <div class="name-card" :style="{ background: card.background }">
            <div class="card-header">
              <div class="card-info">
                <div class="card-name">{{ card.name }}</div>
                <div class="card-pronunciation">{{ card.pronunciation }}</div>
              </div>
              <div class="card-gender-icon">
                <img :src="card.genderIcon" alt="gender" />
              </div>
            </div>
            <div class="card-details">
              <div class="detail-row">
                <span class="detail-label">US Popularity</span>
                <span class="detail-value">{{ card.popularity }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Style</span>
                <span class="detail-value">{{ card.style }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Meaning</span>
                <span class="detail-value text-ellipsis">
                  <span v-for="item in card.meaningList" :key="item">{{ item }} </span></span>
              </div>
            </div>
          </div>
        </router-link>
        <!-- Mobile ad after 1nd card -->
        <AdComponent v-if="deviceType === 'mobile' && index === 0" :key="'ads-names-1'"
          v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.nams_1" ref="ads-names-1"
          class="ad-width-100 " :ads="adsensConfig?.nams_1" :showDebug="showDebug" />

        <!-- Mobile ad after 5th card -->
        <AdComponent v-if="deviceType === 'mobile' && index === 2" :key="'ads-names-2'"
          v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.nams_2" ref="ads-names-2"
          class="ad-width-100 " :ads="adsensConfig?.nams_2" :showDebug="showDebug" />

        <!-- PC ad after 8th card -->
        <AdComponent v-if="deviceType !== 'mobile' && index === 3" :key="'ads-names-1'"
          v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.nams_1" ref="ads-names-1"
          class="ad-width-100  ad-grid-full-width" :ads="adsensConfig?.nams_1"
          :showDebug="showDebug" />
        <!-- PC ad after 8th card -->
        <AdComponent v-if="deviceType === 'mobile' && index === 4" :key="'ads-names-3'"
          v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.nams_3" ref="ads-names-3"
          class="ad-width-100  ad-grid-full-width" :ads="adsensConfig?.nams_3"
          :showDebug="showDebug" />
      </template>
    </div>


    <!-- 组合模块 -->
    <div class="combinations-section" :class="[deviceType]" v-if="combinations.length > 0">
      <div class="combinations-header">
        <div class="combinations-dot"></div>
        <div class="combinations-title">Combinations</div>
      </div>
      <div class="combinations-container">
        <div class="combination-row">
          <div class="combination-card-link" v-for="(combo, index) in combinations" :key="index"
            @click="navigateTo(combo.url)" @mouseenter="hoveredCombination = index"
            @mouseleave="hoveredCombination = null">
            <div class="combination-card" :class="{'hovered': hoveredCombination === index}">
              <div class="combination-text">
                {{ combo.title }}
              </div>
              <div class="see-more-button">
                <span>See More</span>
                <img src="@/assets/default/arrow-right-small.svg" alt="arrow" class="arrow-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
 
    <!--<AdComponent v-if="deviceType === 'mobile' && nameCards.length < 4" :key="'ads-names-3'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.nams_3" ref="ads-names-3"
      class="ad-width-100 " :ads="adsensConfig?.nams_3" :showDebug="showDebug" /> -->

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import SearchFilter from '@/components/SearchFilter.vue';
import AdComponent from '@/pages/components/AdComponent.vue'

import '@/css/common.scss';

export default {
  name: 'Names',
  components: {
    CommonPages,
    SearchFilter,
    AdComponent
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      hoveredCard: null,
      hoveredCombination: null,
      currentPage: 32,
      isGenerateHovered: false,
      isResetHovered: false,
      sortBy: 'S_3',
      sortOptions: [
        { value: 'S_1', label: 'A-Z' },
        { value: 'S_2', label: 'Z-A' },
        { value: 'S_3', label: 'Most Popular' },
        { value: 'S_4', label: 'Most Unique' }
      ],
      defaultFilters: {
        gender: [],
        letter: [],
        style: '',
        meaning: [],
        syllables: '',
        origin: ''
      },
      filters: {
        gender: [],
        letter: [],
        style: '',
        meaning: [],
        syllables: '',
        origin: ''
      },
      azOptions: [
        { value: 'all', label: 'All' },
        { value: 'A', label: 'A' },
        { value: 'B', label: 'B' },
        { value: 'C', label: 'C' },
        { value: 'D', label: 'D' },
        { value: 'E', label: 'E' },
        { value: 'F', label: 'F' },
        { value: 'G', label: 'G' },
        { value: 'H', label: 'H' },
        { value: 'I', label: 'I' },
        { value: 'J', label: 'J' },
        { value: 'K', label: 'K' },
        { value: 'L', label: 'L' },
        { value: 'M', label: 'M' },
        { value: 'N', label: 'N' },
        { value: 'O', label: 'O' },
        { value: 'P', label: 'P' },
        { value: 'Q', label: 'Q' },
        { value: 'R', label: 'R' },
        { value: 'S', label: 'S' },
        { value: 'T', label: 'T' },
        { value: 'U', label: 'U' },
        { value: 'V', label: 'V' },
        { value: 'W', label: 'W' },
        { value: 'X', label: 'X' },
        { value: 'Y', label: 'Y' },
        { value: 'Z', label: 'Z' }
      ],
      syllablesOptions: [
        { value: 'all', label: 'All' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' }
      ],
      originOptions: [
        { value: 'all', label: 'All' },
        { value: 'english', label: 'English' },
        { value: 'french', label: 'French' },
        { value: 'spanish', label: 'Spanish' }
      ],
      nameCards: [],
      combinations: [],
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
      'gender',
      'style',
      'meaning',
      'showDebug',
    ]),
    pageTitle () {
      const origin = this.domainConfig?.origin || '';
      return `All - Browse Thousands of Unique ${origin} Name Ideas`;
    },
    pageDescription () {
      const origin = this.domainConfig?.origin || '';
      return `Explore a comprehensive list of AI-generated ${origin} names by gender, meaning, style, and more.`;
    },
    genderOptions () {
      if (!this.gender || this.gender.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.gender.map(item => ({ label: item, value: item }))];
    },
    styleOptions () {
      if (!this.style || this.style.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.style.map(item => ({ label: item, value: item }))];
    },
    meaningOptions () {
      if (!this.meaning || this.meaning.length === 0) return [{ value: 'all', label: 'All' }];
      return [{ value: 'all', label: 'All' }, ...this.meaning.map(item => ({ label: item, value: item }))];
    },
  },
  async mounted () {
    this.getParamsFromUrl();
    this.fetchNames();
    this.fetchCombinations();

    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  },
  watch: {
    sortBy () {
      this.updateUrlParams();
      this.fetchNames();
    },
  },
  methods: {
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(this.defaultFilters));
      this.sortBy = 'S_3'; // 重置为默认排序

      // 清除URL参数
      if (typeof window !== 'undefined' && window.history) {
        window.history.replaceState({}, '', window.location.pathname);
      }
    },
    // 处理选择变化
    handleSelectChange (filterType) {
      const selectedValues = this.filters[filterType];

      // 如果选择了"all"，则清空其他所有选项
      if (selectedValues.includes('all')) {
        this.filters[filterType] = ['all'];
      }
      // 如果选择了其他选项，则移除"all"
      else if (selectedValues.length > 0) {
        this.filters[filterType] = selectedValues.filter(val => val !== 'all');
      }
      // 如果没有选择任何选项，则默认选择"all"
      else {
        this.filters[filterType] = ['all'];
      }
    },
    // 处理Generate Names按钮点击事件
    handleGenerateClick () {
      // 构建查询参数对象
      const query = {};

      // 添加所有非默认和非'all'的筛选条件
      if (Array.isArray(this.filters.gender) && this.filters.gender.length > 0) {
        // 检查是否包含"all"选项
        if (!this.filters.gender.includes('all')) {
          query.gender = this.filters.gender;
        }
      } else if (this.filters.gender !== 'all') {
        query.gender = [this.filters.gender];
      }

      if (Array.isArray(this.filters.letter) && this.filters.letter.length > 0) {
        // 检查是否包含"all"选项
        if (!this.filters.letter.includes('all')) {
          query.letter = this.filters.letter;
        }
      } else if (this.filters.letter !== 'all') {
        query.letter = [this.filters.letter];
      }

      if (Array.isArray(this.filters.style) && this.filters.style.length > 0) {
        // 检查是否包含"all"选项
        if (!this.filters.style.includes('all')) {
          query.style = this.filters.style;
        }
      } else if (this.filters.style !== 'all') {
        query.style = [this.filters.style];
      }

      if (Array.isArray(this.filters.meaning) && this.filters.meaning.length > 0) {
        // 检查是否包含"all"选项
        if (!this.filters.meaning.includes('all')) {
          query.meaning = this.filters.meaning;
        }
      } else if (this.filters.meaning !== 'all') {
        query.meaning = [this.filters.meaning];
      }

      if (Array.isArray(this.filters.syllables) && this.filters.syllables.length > 0) {
        // 检查是否包含"all"选项
        if (!this.filters.syllables.includes('all')) {
          query.syllables = this.filters.syllables;
        }
      } else if (this.filters.syllables !== 'all') {
        query.syllables = [this.filters.syllables];
      }

      // 如果排序不是默认值，添加排序参数
      if (this.sortBy !== 'S_3') {
        query.sortType = this.sortBy;
      }

      // 构建查询字符串
      const queryString = Object.keys(query)
        .map(key => {
          if (Array.isArray(query[key])) {
            return query[key].map(val =>
              `${encodeURIComponent(key)}[]=${encodeURIComponent(val)}`
            ).join('&');
          }
          return `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`;
        })
        .join('&');

      // 构建新的URL
      const newUrl = `/names${queryString ? `?${queryString}` : ''}`;

      // 使用router.push跳转，保留查询参数
      this.$router.push(newUrl);
    },
    // 更新URL参数，不触发路由变化
    updateUrlParams () {
      // 构建查询参数对象
      const query = {};

      // 只添加非默认值的参数
      if (this.filters.gender !== this.defaultFilters.gender) {
        query.gender = this.filters.gender;
      }

      if (this.filters.letter !== this.defaultFilters.letter) {
        query.letter = this.filters.letter;
      }

      if (this.filters.style !== this.defaultFilters.style) {
        query.style = this.filters.style;
      }

      if (this.filters.meaning !== this.defaultFilters.meaning) {
        query.meaning = this.filters.meaning;
      }

      if (this.filters.syllables !== this.defaultFilters.syllables) {
        query.syllables = this.filters.syllables;
      }

      // 如果排序不是默认值，添加排序参数
      if (this.sortBy !== 'S_3') {
        query.sortType = this.sortBy;
      }

      // 使用replaceState更新URL，不触发路由变化
      if (typeof window !== 'undefined' && window.history) {
        const queryString = Object.keys(query)
          .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
          .join('&');

        const newUrl = window.location.pathname + (queryString ? `?${queryString}` : '');
        window.history.replaceState({}, '', newUrl);
      }
    },
    // 从URL参数获取筛选条件
    getParamsFromUrl () {
      // 使用GetQueryParams获取所有URL参数
      const params = this.$global.GetQueryParams();

      // 更新筛选条件
      Object.keys(this.filters).forEach(key => {
        if (params[key]) {
          // Handle single-select fields
          if (key === 'style' || key === 'syllables' || key === 'origin') {
            this.filters[key] = this.findOriginalCase(params[key], key);
          }
          // Handle multi-select fields
          else {
            const values = Array.isArray(params[key]) ? params[key] : [params[key]];
            // For gender, meaning, and letter, map to original case
            this.filters[key] = this.mapToOriginalCase(values, key);
          }
        }
      });

      // 如果URL中有sortType参数，更新排序方式
      if (params.sortType && this.sortOptions.some(option => option.value === params.sortType)) {
        this.sortBy = params.sortType;
      }
    },
    // 辅助方法：查找原始大小写的选项值
    findOriginalCase (value, type) {
      if (!value) return 'all';

      // 处理特殊情况
      if (value.toLowerCase() === 'all') return 'all';

      const options = this[`${type}Options`];
      if (!options) return value;

      // 查找匹配的选项（忽略大小写）
      const option = options.find(opt =>
        opt.value.toLowerCase() === value.toLowerCase() ||
        opt.label.toLowerCase() === value.toLowerCase()
      );

      if (option) {
        return option.value;
      }

      // For gender, meaning, and style, capitalize the first letter if not found in options
      if (type === 'gender' || type === 'meaning' || type === 'style') {
        if (typeof value === 'string' && value.length > 0) {
          return value.charAt(0).toUpperCase() + value.slice(1);
        }
      }

      return value;
    },
    // 辅助方法：将URL参数值映射到原始大小写
    mapToOriginalCase (values, type) {
      if (!values || !Array.isArray(values)) return ['all'];

      const result = [];
      const options = this[`${type}Options`];

      if (!options) return values.map(v => v);

      for (const value of values) {
        const originalValue = this.findOriginalCase(value, type);
        if (originalValue) {
          result.push(originalValue);
        }
      }

      return result.length > 0 ? result : ['all'];
    },
    fetchNames () {
      // 构建请求参数
      const params = {
        pageSize: '20',
        pageNum: '1',
        sortType: this.sortBy,
      };

      // 添加筛选参数 (多选)
      ['gender', 'letter', 'meaning'].forEach(key => {
        const filterValue = this.filters[key];
        if (Array.isArray(filterValue) && filterValue.length > 0 && !filterValue.some(v => typeof v === 'string' && v.toLowerCase() === 'all')) {
          params[key] = filterValue;
        }
      });

      // 添加筛选参数 (单选)
      ['style', 'syllables'].forEach(key => {
        const filterValue = this.filters[key];
        if (filterValue && typeof filterValue === 'string' && filterValue.toLowerCase() !== 'all') {
          if (key === 'syllables') {
            const numSyllables = parseInt(filterValue, 10);
            if (!isNaN(numSyllables)) {
              params[key] = numSyllables;
            }
          } else if (key === 'style') {
            params[key] = filterValue.charAt(0).toUpperCase() + filterValue.slice(1);
          } else {
            params[key] = filterValue;
          }
        }
      });

      // 从domainConfig获取origin
      if (this.domainConfig && this.domainConfig.origin) {
        params.origin = this.domainConfig.origin;
      }

      this.$global.server.postAPI({
        method: 'post',
        params: params,
        url: '/name/page',
      })
        .then(response => {
          if (response && response.data && response.data.list) {
            this.nameCards = response.data.list.map(item => {
              const GENDER_COLORS = {
                Boy: 'linear-gradient(180deg, rgba(0, 136, 255, 1) 0%, rgba(0, 136, 255, 0.2) 100%)',
                Girl: 'linear-gradient(180deg, rgba(229, 76, 186, 1) 0%, rgba(229, 76, 186, 0.2) 100%)',
                Unisex: 'linear-gradient(180deg, rgba(200, 173, 23, 1) 0%, rgba(200, 173, 23, 0.2) 100%)'
              };
              return {
                id: item.id || '',
                name: item.name || '',
                gender: item.gender || 'Boy',
                genderIcon: item.gender === 'Boy'
                  ? require('@/assets/icons/male.svg')
                  : item.gender === 'Unisex'
                    ? require('@/assets/icons/unsex.svg')
                    : require('@/assets/icons/female.svg'),
                pronunciation: item.pronunciation || '',
                style: item.style || '',
                meaning: item.meaning || '',
                meaningList: item.meaningList || [],
                popularity: item.popularity || '',
                background: GENDER_COLORS[item.gender] || GENDER_COLORS.Boy
              };
            });
            console.log('名字列表获取成功:', response.data);
          }
        })
        .catch(error => {
          console.error('获取名字列表失败:', error);
        });
    },
    async fetchCombinations () {
      const origin = this.domainConfig?.origin || '';
      try {
        const params = { origin };
        const response = await this.$global.server.postAPI({
          method: 'get',
          params,
          url: '/name/combinations',
        });
        if (response.data && response.data.combinations) {
          this.combinations = response.data.combinations.slice(0, 4);
        }
      } catch (error) {
        console.error('Error fetching combinations:', error);
        this.combinations = [];
      }
    },
    navigateTo (url) {
      if (url) {
        this.$router.push(url);
      }
    },
  }
};
</script>

<style lang="scss" >
@import '~@/css/variables.scss';
.el-select-dropdown__list {
	padding: rem(3) 0;
}
.el-select-dropdown__item {
	padding: 0 rem(3) !important;
}
.el-select-dropdown__item.selected {
	color: #000;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
	background: rgba(0, 0, 0, 0.1);
}
.el-form {
	padding-bottom: 0;
}
.el-input__inner {
	border-radius: rem(20);
	border: rem(2) solid rgba(0, 0, 0, 0.1);
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
	border-color: #fff;
}
.el-input__inner:hover {
	border-color: rgba(0, 0, 0, 0.3);
}
.el-select:hover .el-input__inner {
	border-color: rgba(0, 0, 0, 0.3);
}
.el-select .el-input__inner:focus {
	border-color: #fff;
}
.el-select__caret {
	color: #fff !important;
}
.sort-select {
	width: rem(140);
	.el-input__inner {
		border: none;
		color: #fff;
		padding: 0 !important;
		font-size: rem(16);
		font-style: normal;
		font-weight: 700;
		line-height: rem(16); /* 100% */
		text-transform: capitalize;
	}
}
.el-select__tags {
	max-width: calc(100% - rem(30));
}
.el-tag {
	background-color: rgba(0, 0, 0, 0.1);
	border-color: rgba(0, 0, 0, 0.2);
	color: #fff;
}
.el-tag .el-tag__close {
	color: #fff;
}
.el-tag .el-tag__close:hover {
	background-color: #fff;
	color: #fff;
}

.detect_deviece_mobile {
	.el-select-dropdown__item {
		font-size: rem(13);
		line-height: rem(34);
		height: rem(34);
	}
	.el-input__inner {
		height: rem(60);
		padding: rem(18) rem(44) rem(18) rem(24);
		border-radius: rem(20);
		border: rem(2) solid rgba(255, 255, 255, 0.1);
		background: #000;
		color: #fff;
		font-size: rem(16);
		font-style: normal;
		font-weight: 500;
		line-height: rem(16); /* 100% */
		text-transform: capitalize;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
	}
	.el-input__suffix {
		right: rem(24);
	}
	.el-select__caret {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
	.sort-select {
		.el-input__inner {
			border: none !important;
			border-radius: 0;
			color: #fff;
			font-size: rem(16);
			font-style: normal;
			font-weight: 700;
			height: rem(16); /* 100% */
			line-height: rem(16); /* 100% */
			text-transform: capitalize;
		}
		.el-input__suffix {
			right: rem(8);
		}
		.el-select__caret {
			font-size: rem(16);
		}
	}
}
</style>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.ad-grid-full-width {
	grid-column: 1 / -1;
}
.names {
	// 搜索过滤区域样式
	.names-filter {
		padding: rem(16) 0 rem(32) 0;
		display: flex;
		flex-direction: column;
		gap: rem(24);
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		padding: rem(32) rem(180);
		&.mobile {
			.opacity-0 {
				display: none !important;
			}
		}
		.filter-container {
			padding: 0 rem(180);
			display: flex;
			flex-direction: column;
			gap: rem(10);
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			position: relative;

			background: linear-gradient(139.77deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.9) 59.95%, rgba(255, 255, 255, 0.6) 100%);
			border-radius: rem(36);
			border: rem(2) solid #ffffff;
			box-shadow: 0 rem(2) rem(4) 0 rgba(0, 0, 0, 0.08);
			padding: rem(32);
			width: 100%;
			box-sizing: border-box;

			.filter-rows {
				display: flex;
				flex-direction: column;
				gap: rem(24);
				align-items: flex-start;
				justify-content: flex-start;
				width: 100%;
				position: relative;

				.filter-row {
					display: flex;
					flex-direction: row;
					gap: rem(28);
					align-items: center;
					justify-content: flex-start;
					align-self: stretch;
					position: relative;

					.filter-item {
						display: flex;
						flex-direction: column;
						gap: rem(8);
						align-items: flex-start;
						justify-content: flex-start;
						flex: 1;
						position: relative;

						&.opacity-0 {
							opacity: 0;
						}

						.filter-label {
							padding: 0 rem(20);
							color: #03133a;
							text-align: left;
							font-size: rem(16);
							line-height: rem(16);
							font-weight: 400;
							position: relative;
						}

						:deep(.filter-select) {
							width: 100%;
							border-radius: rem(20);

							.el-input__wrapper {
								background: #ffffff;
								border-radius: rem(20);
								border: rem(2) solid rgba(0, 0, 0, 0.1);
								padding: rem(18) rem(24);
								box-shadow: none !important;
								height: rem(60);
								transition: all 0.3s ease;
								cursor: pointer;

								&:hover {
									border-color: rgba(0, 0, 0, 0.3);
								}

								&.is-focus {
									border-color: #fff;
								}

								.el-input__inner {
									color: #03133a;
									font-size: rem(18);
									line-height: rem(20);
									font-weight: 700;
									height: 100%;
									max-width: calc(100% - rem(20));
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
								}
							}

							&.active .el-input__wrapper {
								border-color: #fff;
							}

							.el-select__caret {
								color: #03133a;
								font-size: rem(18);
							}
						}
					}
				}
			}

			.filter-actions {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;
				align-self: stretch;
				position: relative;
				margin-top: rem(48);

				.generate-button {
					background: #a31984;
					border-radius: rem(100);
					padding: rem(20) rem(32);
					display: flex;
					flex-direction: row;
					gap: rem(16);
					align-items: center;
					justify-content: center;
					width: rem(320);
					height: rem(60);
					position: relative;
					cursor: pointer;
					transition: all 0.3s ease;

					&.hovered {
						opacity: 0.8;
					}

					.generate-icon {
						width: rem(28);
						height: rem(28);
					}

					span {
						color: #ffffff;
						text-align: center;
						font-size: rem(22);
						line-height: rem(24);
						font-weight: 900;
						position: relative;
					}
				}

				.reset-button {
					border-radius: rem(100);
					border: rem(1) solid #a31984;
					display: flex;
					flex-direction: row;
					gap: rem(16);
					align-items: center;
					justify-content: center;
					width: rem(160);
					height: rem(60);
					position: relative;
					cursor: pointer;
					transition: all 0.3s ease;

					&.hovered {
						background: #a31984;

						span {
							color: #ffffff;
						}

						.reset-icon {
							filter: brightness(0) invert(1);
						}
					}

					.reset-icon {
						width: rem(20);
						height: rem(20);
					}

					span {
						color: #a31984;
						text-align: left;
						font-size: rem(20);
						line-height: rem(20);
						font-weight: 700;
						position: relative;
					}
				}
			}
		}

		&.mobile {
			padding: rem(16) rem(16) rem(32) rem(16);

			.filter-container {
				padding: rem(20);

				.filter-rows {
					gap: rem(16);

					.filter-row {
						flex-direction: column;
						gap: rem(16);
					}
				}

				.filter-actions {
					flex-direction: column;
					gap: rem(16);

					.generate-button,
					.reset-button {
						width: 100%;
					}
				}
			}
		}
	}

	// 结果标题区域样式
	.results-header {
		padding: 0 rem(180) rem(24) rem(180);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		position: relative;

		.results-dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
			margin-right: rem(16);
		}

		.results-title {
			color: #fff;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
			margin-right: auto;
		}

		.sort-container {
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			justify-content: flex-end;
			position: relative;

			.sort-label {
				color: #fff;
				font-size: rem(14);
				font-style: italic;
				font-weight: 300;
				line-height: rem(16); /* 114.286% */
				text-transform: capitalize;
			}

			:deep(.sort-dropdown) {
				.el-select-dropdown__item {
					color: #03133a;
					font-size: rem(14);
					line-height: rem(28);
					padding: rem(8) rem(16) !important;

					&.selected {
						color: #fff;
						font-weight: 700;
					}

					&.hover,
					&:hover {
						background: rgba(0, 0, 0, 0.1);
					}
				}
			}
		}

		&.mobile {
			padding: rem(40) rem(16) rem(16) rem(16);
			flex-direction: column;
			align-items: flex-start;
			gap: rem(16);

			.results-header-top {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-start;
				width: 100%;

				.results-dot {
					background: #a31984;
					border-radius: rem(100);
					width: rem(8);
					height: rem(4);
					position: relative;
					margin-right: rem(16);
				}

				.results-title {
					color: #fff;
					text-align: left;
					font-size: rem(28);
					line-height: rem(28);
					font-weight: 900;
					position: relative;
					margin-right: 0;
				}
			}

			.sort-container {
				justify-content: flex-start;
			}
		}
	}

	// 名字列表区域样式
	.names-list {
		padding: 0 rem(180) rem(32);
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: rem(24);

		.name-card-link {
			text-decoration: none;
		}

		.name-card {
			border-radius: rem(16);
			padding: rem(16);
			display: flex;
			flex-direction: column;
			gap: rem(16);
			width: 100%;
			box-sizing: border-box;
			cursor: pointer;
			transition: all 0.3s ease;

			&:hover {
				transform: translateY(rem(-4));
			}

			.card-header {
				display: flex;
				justify-content: space-between;
				align-self: stretch;

				.card-info {
					display: flex;
					flex-direction: column;
					gap: rem(8);

					.card-name {
						color: #ffffff;
						font-size: rem(20);
						line-height: rem(20);
						font-weight: 900;
					}

					.card-pronunciation {
						color: #ffffff;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 300;
						font-style: italic;
					}
				}

				.card-gender-icon {
					width: rem(24);
					height: rem(24);
					background: #fff;
					border-radius: rem(8);
					display: flex;
					align-items: center;
					justify-content: center;

					img {
						width: rem(16);
						height: rem(16);
					}
				}
			}

			.card-details {
				display: flex;
				flex-direction: column;
				gap: rem(8);
				align-self: stretch;

				.detail-row {
					background: rgba(255, 255, 255, 0.1);
					border-radius: rem(8);
					padding: rem(8) rem(12);
					display: flex;
					justify-content: space-between;
					align-items: center;
					height: rem(32);
					box-sizing: border-box;

					.detail-label {
						color: #ffffff;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 300;
					}

					.detail-value {
						color: #ffffff;
						font-size: rem(13);
						line-height: rem(14);
						font-weight: 700;

						&.text-ellipsis {
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							width: 50%;
							text-align: right;
						}
					}
				}
			}
		}

		&.mobile {
			padding: 0 rem(16);
			grid-template-columns: 1fr;
			gap: rem(16);
		}
	}

	// 组合模块样式
	.combinations-section {
		padding: rem(40) rem(180) rem(80) rem(180);
		display: flex;
		flex-direction: column;
		gap: rem(24);

		.combinations-header {
			.combinations-title {
				color: #ffffff;
				font-size: rem(24);
				font-weight: 900;
			}
		}

		.combinations-container {
			.combination-row {
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				gap: rem(24);
			}

			.combination-card-link {
				text-decoration: none;
				padding: rem(2);
				border-radius: rem(16);
				background: transparent;
				transition: all 0.3s ease;
				&:hover {
					background: linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);
				}
			}

			.combination-card {
				background: rgb(26, 26, 26);
				border-radius: rem(14);
				padding: rem(24);
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				height: rem(172);
				box-sizing: border-box;
				cursor: pointer;

				.combination-text {
					color: #ffffff;
					font-size: rem(18);
					line-height: rem(24);
					font-weight: 700;
				}

				.see-more-button {
					background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
					border-radius: rem(8);
					padding: rem(8) rem(16);
					display: flex;
					align-items: center;
					justify-content: center;
					gap: rem(8);
					width: rem(100);
					height: rem(28);
					box-sizing: border-box;

					span {
						color: #ffffff;
						font-size: rem(12);
						font-weight: 700;
					}

					img {
						width: rem(6);
						height: rem(10);
						filter: brightness(0) invert(1);
					}
				}
			}
		}

		&.mobile {
			padding: rem(40) rem(16);

			.combinations-container {
				.combination-row {
					display: flex;
					overflow-x: auto;
					gap: rem(16);
					padding: 0 rem(16);
					margin: 0 rem(-16);
					&::-webkit-scrollbar {
						display: none;
					}
					-ms-overflow-style: none;
					scrollbar-width: none;
				}
				.combination-card-link {
					flex-shrink: 0;
					width: rem(280);
				}
			}
		}
	}
}

.detect_deviece_mobile {
}
</style> 